import facebook from '../helpers/facebook';
//import Cart from '../globalCart/Cart';

const join = (function () {
  let state = {
    loading: false
  }

  let _cart = null;

  function _submit(data) {
    let captcha = grecaptcha.getResponse().length;
    if (captcha) {
      console.log(data)
      if (!state.loading) {
        state.loading = true;
        $.ajax({
          method: 'POST',
          url: SITE_URL + 'join/submit',
          data,
          success: function (response) {
            response = JSON.parse(response)
            if (response.user_id) {
              window.location.href = SITE_URL + 'alert?type=verify'
              state.loading = false;
            } else {
              window.alert('Valami hiba történt, kérjük próbálja újra később!')
              state.loading = false;
            }
          },
          error: function (error) {
            window.alert(error.responseText)
            state.loading = false;
            grecaptcha.reset();
          }
        })
      }
    } else {
      window.alert('Hiányzó captcha!');
    }
  }

  function _setupListeners() {
    $('.btn-fb').click(function () {
      facebook.login(function (result) {
        console.log(result)
        result = JSON.parse(result);
        if (result.success) {
          window.location.href = SITE_URL
        } else if (result.error) {
          window.alert(result.error)
        }
      })
    })

    $('[name=lastname], [name=firstname]').on('input', function() {
      $(this).val($(this).val().replaceAll('%', ''));
      $(this).val($(this).val().replaceAll('"', ''));
      $(this).val($(this).val().replaceAll('<', ''));
      $(this).val($(this).val().replaceAll('>', ''));
      $(this).val($(this).val().replaceAll('/', ''));
      $(this).val($(this).val().replaceAll('&', ''));
    })

    $('[name=email]').on('input', function() {
      $(this).val($(this).val().replace(/[^a-z0-9@_.\- ]/gi, ''));
    });

    $("#reg_form").on('submit', function (e) {
      e.preventDefault();
      let data = {
        lastname: $('[name=lastname]').val(),
        firstname: $('[name=firstname]').val(),
        email: $('[name=email]').val(),
        password: $('[name=password]').val(),
        password_confirm: $('[name=password_confirm]').val(),
        captcha: grecaptcha.getResponse()
      }
      _submit(data);
    })
  }

  return {
    init: () => {
      console.log('init')
      facebook.init();
      _setupListeners();
      //_cart = new Cart();
    }
  }
})()

export default join;